import { RadioField } from '@calendly/form';
import { object, mixed, string } from '@calendly/form/validation';
import { I18n } from '@calendly/i18n';
import { useTooltip } from '@calendly/ui/components/tooltip';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { PHONE_CALL_KINDS } from '../../constants';
import { popupSelector, possibleKindsSelector, disabledTooltipSelector } from '../../selectors';
import { useStateValue } from '../../state_provider';
import { GeneralPopup } from '../general_popup';
import { InboundCallDetails } from './inbound_call_details';
import { RadioLabel } from './radio_label';
const fieldsetCss = "f1iwes8";
const Fieldset = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldsetCss, props.className)} />;
});
const tooltipContainerCss = "t1tfx9p9";
const TooltipContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tooltipContainerCss, props.className)} />;
});
export const PhoneCallPopup = () => {
  const {
    data: {
      kind: defaultKind,
      phone_number: defaultPhoneNumber,
      additional_info: defaultAdditionalInfo
    }
  } = popupSelector(useStateValue());
  const possibleKinds = possibleKindsSelector(useStateValue());
  const isOutboundCallDisabled = !possibleKinds.includes(PHONE_CALL_KINDS.outbound);
  const tooltipText = disabledTooltipSelector(useStateValue());
  const [Tooltip, tooltipHostProps] = useTooltip(tooltipText);
  const tooltipContainerProps = isOutboundCallDisabled ? tooltipHostProps : {};
  const initialValues = {
    kind: defaultKind || (isOutboundCallDisabled ? PHONE_CALL_KINDS.inbound : PHONE_CALL_KINDS.outbound),
    phoneNumber: defaultPhoneNumber || '',
    additionalInfo: defaultAdditionalInfo || ''
  };
  const validationSchema = object({
    phoneNumber: mixed().when('kind', {
      is: PHONE_CALL_KINDS.inbound,
      then: string().required(I18n.t('errors.event_types.phone_number')).phoneNumber(I18n.t('errors.event_types.phone_number'))
    })
  });
  return <GeneralPopup initialValues={initialValues} validationSchema={validationSchema}>
      <Fieldset>
        <TooltipContainer {...tooltipContainerProps}>
          <RadioField bulletPosition="top" label={<RadioLabel kind={PHONE_CALL_KINDS.outbound} isDisabled={isOutboundCallDisabled} />} name="kind" value={PHONE_CALL_KINDS.outbound} disabled={isOutboundCallDisabled} />
          <Tooltip />
        </TooltipContainer>
        <RadioField bulletPosition="top" label={<RadioLabel kind={PHONE_CALL_KINDS.inbound} />} name="kind" value={PHONE_CALL_KINDS.inbound} />
        <InboundCallDetails />
      </Fieldset>
    </GeneralPopup>;
};

require("./phone_call_popup.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./phone_call_popup.js");